export const PWA_INSTALL_DISMISS_STORAGE_KEY = 'pwa-install-dismissed-until';
export const PWA_INSTALL_DISMISS_DURATION_DAYS = 14;

export function readPwaInstallDismissedUntil(storage: Storage): number | null {
  try {
    const rawValue = storage.getItem(PWA_INSTALL_DISMISS_STORAGE_KEY);
    if (!rawValue) return null;

    const parsed = Number.parseInt(rawValue, 10);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writePwaInstallDismissal(
  storage: Storage,
  now = Date.now(),
  durationDays = PWA_INSTALL_DISMISS_DURATION_DAYS
): number {
  const dismissedUntil = now + durationDays * 24 * 60 * 60 * 1000;

  try {
    storage.setItem(PWA_INSTALL_DISMISS_STORAGE_KEY, dismissedUntil.toString());
  } catch {
    return dismissedUntil;
  }

  return dismissedUntil;
}

export function clearPwaInstallDismissal(storage: Storage): void {
  try {
    storage.removeItem(PWA_INSTALL_DISMISS_STORAGE_KEY);
  } catch {
    return;
  }
}
